import { type FC } from 'react';

import { EsgCategory } from '@/api/esg/models/EsgCategory';
import { EsgCurrencyCategory } from '@/api/esg/models/EsgCurrencyCategory';
import { WithGap } from '@/components/WithGap';
import { useTexts } from '@/hooks/useTexts';
import { CurrencyCode } from '@/types/CurrencyCode';

import { EsgCarbonFootprintComparison } from './EsgCarbonFootprintComparison';
import { EsgCarbonFootprintTonnage } from './EsgCarbonFootprintTonnage';

interface Props {
  esgCarbonIntensities: EsgCurrencyCategory[];
  pai11GhgEmissionsSum: EsgCategory | undefined;
}

export const EsgCarbonFootprint: FC<Props> = ({
  esgCarbonIntensities,
  pai11GhgEmissionsSum,
}) => {
  const texts = useTexts();

  const carbonFootprintData = esgCarbonIntensities.find(
    (score) => score.currency === CurrencyCode.NOK,
  );

  return (
    <WithGap>
      <p className="font-body">{texts.pages.esg.carbonFootprint.description}</p>

      {carbonFootprintData?.benchmark ? (
        <EsgCarbonFootprintComparison data={carbonFootprintData} />
      ) : (
        <EsgCarbonFootprintTonnage data={pai11GhgEmissionsSum} />
      )}
    </WithGap>
  );
};
